import React from "react";
import { ExcludeIcon, EyeIcon, CheckIcon } from "../../images/icons/icons";

const ActionButtons = ({
  rowData,
  setModValues,
  showPTTrial = true,
  showMapTrainer = true,
  showView = true,
  showResolve = true,
  customActions = [],
}) => {
  const handleActionClick = (modName) => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: modName,
      rowData: rowData,
    }));
  };

  const isResolved = rowData?.is_resolved;

  return (
    <div className="pp-employee-payroll-actions">
      {showPTTrial && (
        <button
          key="pt-trainer"
          type="button"
          className="pp-employee-payroll-action-button pp-outlined-border"
          onClick={() => handleActionClick("trial_assign")}
        >
          <ExcludeIcon />
          PT trial
        </button>
      )}

      {showMapTrainer && (
        <button
          key="map-trainer"
          type="button"
          className="pp-employee-payroll-action-button pp-outlined-border"
          onClick={() => handleActionClick("trainer_member_map")}
        >
          <ExcludeIcon />
          map trainer
        </button>
      )}

      {showView && (
        <button
          key="available-trainers"
          type="button"
          className="pp-employee-payroll-action-button pp-outlined-border"
          onClick={() => handleActionClick("view_details")}
        >
          <EyeIcon />
          view
        </button>
      )}

      {showResolve && (
        <button
          key="resolve"
          type="button"
          className={`pp-employee-payroll-action-button ${
            isResolved ? "pp-btn-resolved disabled" : "pp-outlined-border"
          }`}
          onClick={() => (isResolved ? null : handleActionClick("resolve"))}
          disabled={isResolved}
        >
          <CheckIcon />
          {isResolved ? "Resolved" : "resolve"}
        </button>
      )}

      {customActions.map((action, index) => (
        <button
          key={action.key || `custom-${index}`}
          type="button"
          className={`pp-employee-payroll-action-button ${
            action.className || "pp-outlined-border"
          }`}
          onClick={() => handleActionClick(action.modName)}
          disabled={action.disabled}
        >
          {action.icon}
          {action.label}
        </button>
      ))}
    </div>
  );
};

export default ActionButtons;
